export const setSpeed = (payload) => {
    return {
        type: 'SET_SPEED',
        payload: payload
    }
};
